const RUNTIME_ENV =
    typeof window !== 'undefined' && window.__ENV__ && typeof window.__ENV__ === 'object'
        ? window.__ENV__
        : {};

const BUILD_ENV = {
    REACT_APP_TRUE_DEV: process.env.REACT_APP_TRUE_DEV,
    REACT_APP_UPLOAD_PRESET: process.env.REACT_APP_UPLOAD_PRESET,
    REACT_APP_CLOUD_NAME: process.env.REACT_APP_CLOUD_NAME,
    REACT_GOOGLE_ANALYTICS: process.env.REACT_GOOGLE_ANALYTICS,
    REACT_FACEBOOK_PIXEL: process.env.REACT_FACEBOOK_PIXEL,
    REACT_GOOGLE_ADS: process.env.REACT_GOOGLE_ADS,
    REACT_MIXPANEL_TOKEN: process.env.REACT_MIXPANEL_TOKEN,
    REACT_MIXPANEL_SESSION_REPLAY_PERCENT: process.env.REACT_MIXPANEL_SESSION_REPLAY_PERCENT,
    REACT_APP_MIXPANEL_SESSION_REPLAY_PERCENT: process.env.REACT_APP_MIXPANEL_SESSION_REPLAY_PERCENT,
    REACT_NODE_ENV: process.env.REACT_NODE_ENV,
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    REACT_BACKEND_URL: process.env.REACT_BACKEND_URL,
    REACT_APP_SUBSCRIPTION_URL: process.env.REACT_APP_SUBSCRIPTION_URL,
    REACT_SUBSCRIPTION_URL: process.env.REACT_SUBSCRIPTION_URL,
    REACT_APP_STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    REACT_STRIPE_PUBLISHABLE_KEY: process.env.REACT_STRIPE_PUBLISHABLE_KEY,
};

const getEnv = (keys, fallback) => {
    const names = Array.isArray(keys) ? keys : [keys];
    for (const name of names) {
        const runtimeValue = RUNTIME_ENV[name];
        if (typeof runtimeValue === 'string' && runtimeValue.trim().length > 0) {
            return runtimeValue;
        }

        const buildValue = BUILD_ENV[name];
        if (typeof buildValue === 'string' && buildValue.trim().length > 0) {
            return buildValue;
        }
    }
    return fallback;
};

export const TRUE_DEV = getEnv('REACT_APP_TRUE_DEV', 'true') !== 'false';

const environment = {
    REACT_APP_UPLOAD_PRESET: getEnv(
        'REACT_APP_UPLOAD_PRESET',
        !TRUE_DEV ? 'uyxj6esi' : 'oioovlwm'
    ),
    REACT_APP_CLOUD_NAME: getEnv(
        'REACT_APP_CLOUD_NAME',
        !TRUE_DEV ? 'luckyimagecloud' : 'djtncwjv1'
    ),
    REACT_GOOGLE_ANALYTICS: getEnv('REACT_GOOGLE_ANALYTICS', 'UA-171693503-1'),
    REACT_FACEBOOK_PIXEL: getEnv('REACT_FACEBOOK_PIXEL', '3049294228689093'),
    REACT_GOOGLE_ADS: getEnv('REACT_GOOGLE_ADS', 'AW-10818851857'),
    REACT_MIXPANEL_TOKEN: getEnv('REACT_MIXPANEL_TOKEN', '8ab40e3b3d36b3f38366602c71fd990a'),
    REACT_MIXPANEL_SESSION_REPLAY_PERCENT: getEnv(
        ['REACT_MIXPANEL_SESSION_REPLAY_PERCENT', 'REACT_APP_MIXPANEL_SESSION_REPLAY_PERCENT'],
        '0'
    ),
    REACT_NODE_ENV: getEnv('REACT_NODE_ENV', process.env.NODE_ENV || 'development'),
    REACT_BACKEND_URL: getEnv(
        ['REACT_APP_BACKEND_URL', 'REACT_BACKEND_URL'],
        TRUE_DEV ? 'http://localhost:4000/graphql' : 'https://luckynote.io/graphql'
    ),
    REACT_SUBSCRIPTION_URL: getEnv(
        ['REACT_APP_SUBSCRIPTION_URL', 'REACT_SUBSCRIPTION_URL'],
        TRUE_DEV ? 'ws://localhost:4000/graphql' : 'wss://luckynote.io/graphql'
    ),
    REACT_STRIPE_PUBLISHABLE_KEY: getEnv(
        ['REACT_APP_STRIPE_PUBLISHABLE_KEY', 'REACT_STRIPE_PUBLISHABLE_KEY'],
        'pk_test_LqsJMpLVp70JgQ0u4t2WTNKi00fmLbSdyF'
    )
};

export default environment;
